import { render, staticRenderFns } from "./r-delete-button.vue?vue&type=template&id=621df7a2&scoped=true&"
import script from "./r-delete-button.vue?vue&type=script&lang=js&"
export * from "./r-delete-button.vue?vue&type=script&lang=js&"
import style0 from "./r-delete-button.vue?vue&type=style&index=0&id=621df7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621df7a2",
  null
  
)

/* custom blocks */
import block0 from "./r-delete-button.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports